<template>
  <div>
    <field-mapper
      v-if="!$apollo.loading"
      page-title="Subscription Requirements"
      :list="list"
      :disable-editing-fields="disableEditingFields"
      @save="handleSave"
    />
    <spinner v-else />
  </div>
</template>

<script>
import FieldMapper from '@/components/FieldMapper.vue'
import {
  GET_ORGANIZATION_ATTENDEE_FIELDS,
  UPDATE_ORGANIZATION_ATTENDEE_FIELDS,
} from '@/graphql/organization.graphql'
import { listOrderComparator } from '@/components/accreditations/attendee-fields'
import { objectToArray } from '@/utils'

export default {
  name: 'sport-subscription-requirements',
  components: { FieldMapper },
  props: {
    organizationSlug: String,
  },
  data() {
    return {
      list: [],
      allAttendeeFields: {},
      disableEditingFields: false,
    }
  },
  methods: {
    async handleSave(newFields) {
      this.allAttendeeFields.subscriptionFields = newFields

      await this.$apollo.mutate({
        mutation: UPDATE_ORGANIZATION_ATTENDEE_FIELDS,
        variables: {
          organizationSlug: this.organizationSlug,
          attendeeFields: this.allAttendeeFields,
        },
      })
    },
    orderList(list) {
      return list.sort(listOrderComparator)
    },
    mapFieldsToList(fields) {
      return objectToArray(fields, 'name')
    },
  },
  apollo: {
    getSortedAttendeeFields: {
      query: GET_ORGANIZATION_ATTENDEE_FIELDS,
      variables() {
        return {
          organizationSlug: this.organizationSlug,
        }
      },
      manual: true,
      result({
        data: {
          getOrganizationBySlug: { attendeeFields, hasOrganizationPrepaidCouponUsers },
        },
        loading,
      }) {
        if (!loading) {
          this.disableEditingFields = hasOrganizationPrepaidCouponUsers
          if (!attendeeFields || !attendeeFields.subscriptionFields) return (this.list = [])

          this.allAttendeeFields = attendeeFields
          this.list = this.orderList(this.mapFieldsToList(attendeeFields.subscriptionFields))
        }
      },
    },
  },
}
</script>
